import { Type } from 'class-transformer';
import { Model } from './model';
import { EmailTemplate } from './email_template';

export class OutreachRule extends Model {
  id: string;

  group_id: string;

  rule_type: RuleType;

  // invoice based rules
  invoice_selection: DateRuleInvoiceSelection | null;

  age_comparison: DateRuleAgeComparison | null;

  days: number | null;

  time_direction: DateRuleTimeDirection | null;

  date_type: DateRuleInvoiceDateType | null;

  // account based rules
  aging_bucket: AgingRuleBucket | null;

  threshold_type: AgingRuleThresholdType | null;

  threshold_value_amount: number | null;

  threshold_value_percentage: number | null;

  balance_category: AgingRuleBalanceCategory | null;

  // action config
  action_type: OutreachActionType;

  email_template_id: string | null;

  ai_email: boolean;

  autosend: boolean;

  is_enabled: boolean;

  @Type(() => EmailTemplate)
  email_template: EmailTemplate | null;
}

export enum RuleType {
  DATE = 'date_based',
  AGING = 'aging_based',
}

export enum OutreachActionType {
  EMAIL = 'email',
  CALL = 'call',
  SMS = 'sms',
}

export enum DateRuleInvoiceSelection {
  ANY = 'any_invoice',
  OLDEST = 'oldest_invoice',
}

export enum DateRuleAgeComparison {
  EXACTLY = 'exactly',
  ATLEAST = 'at_least',
}

export enum DateRuleTimeDirection {
  BEFORE = 'before',
  AFTER = 'after',
  ON = 'on',
}

export enum DateRuleInvoiceDateType {
  DUE = 'due_date',
  ISSUED = 'issue_date',
}

export enum AgingRuleThresholdType {
  AMOUNT = 'amount',
  PERCENTAGE = 'percentage',
}

export enum AgingRuleBalanceCategory {
  TOTAL = 'total',
  OVERDUE = 'overdue',
}

export enum AgingRuleBucket {
  NOTOVERDUE = 'not_overdue',
  DAYS1TO30 = 'days_1_30',
  DAYS31TO60 = 'days_31_60',
  DAYS61TO90 = 'days_61_90',
  DAYSOVER90 = 'days_over_90',
}
